import { Component, OnInit, ViewChild } from '@angular/core';
import { KontableComponent } from "../../../modules/UIKit/components/kontable/kontable.component";
import { CustomerSetImportService } from 'app/services/customer/customer-set-import.service';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-customer-set-import',
  templateUrl: './customer-set-import.component.html',
  styleUrls: ['./customer-set-import.component.css']
})
export class CustomerSetImportComponent implements OnInit {

  paginationType = KontableComponent.ServerPagination;


  @ViewChild('table') table: any;

  translations: any;
  service: any;
  customerImport: any;
  showDetail: boolean;
  actualRow;


  constructor(
    public customerSetImportService: CustomerSetImportService,
    private router: Router,
    private message: MessageService,

  ) {
    this.service = this.customerSetImportService;
  }

  ngOnInit() {
  }


  addImport() {
    this.router.navigate(['clustering-import/form']);
  }

  deleteImport(id) {
    this.customerSetImportService.deleteQueryImport(id).subscribe(
      ()=> {
        this.message.add({severity: 'success', summary: 'Success', detail: 'Record Deleted'})
        this.table.refresh();
      }
    )
  }

  openDetailDialog(row) {
    this.customerSetImportService.getImportDetails(row.id).subscribe(res => {
      this.actualRow = res[0];
      this.showDetail = true;
    })
  }

  closeDetailDialog() {
    this.actualRow = null;
    this.showDetail = false;
  }


}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customer-set-import/customer-set-import.component.ts